import React from 'react'

import InputContainer from '../ncss/InputContainer.js'

export default ({ meta, children, ...props }) => (
  <InputContainer {...props} error={meta.touched && meta.error}>
    {children}
  </InputContainer>
)



// WEBPACK FOOTER //
// ./client/src/components/forms/InputContainer.js